// =====================================================
// 📁 QuotationSummaryPanel.tsx
// =====================================================

import QuotationFooterActions from '../../footer/QuotationFooterActions';

import QuotationSelectedProducts from './QuotationSelectedProducts';

import QuotationSummaryTotals from './QuotationSummaryTotals';

import QuotationSummaryEmpty from './QuotationSummaryEmpty';

import { useQuotation } from '../../../../../../hooks/sale/useQuotation';

const QuotationSummaryPanel = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form } = useQuotation();

  // =====================================================
  // 🔹 Values
  // =====================================================
  const products = form?.items || [];

  const productsCount = products.length;

  const hasProducts = productsCount > 0;

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <section
      className="
      sticky
      top-4

      h-fit

      overflow-hidden

      rounded-2xl

      border
      border-stroke

      bg-whiter

      shadow-1

      dark:border-strokedark
      dark:bg-boxdark-2
    "
    >
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}
      <div
        className="
        flex
        items-start
        justify-between

        border-b
        border-stroke

        bg-gray-2

        px-5
        py-4

        dark:border-strokedark
        dark:bg-boxdark
      "
      >
        <div>
          <h2
            className="
            text-lg
            font-semibold

            text-black

            dark:text-white
          "
          >
            Resumen de Cotización
          </h2>

          <p
            className="
            mt-1

            text-sm

            text-body

            dark:text-bodydark1
          "
          >
            Productos agregados a la cotización
          </p>
        </div>

        <div
          className="
          rounded-xl

          border
          border-primary/20

          bg-primary/10

          px-3
          py-1.5

          text-sm
          font-semibold

          text-primary
        "
        >
          {productsCount} {productsCount === 1 ? 'producto' : 'productos'}
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}
      <div className="space-y-5 p-5">
        {hasProducts ? (
          <>
            {/* 🔹 Products */}
            <QuotationSelectedProducts />

            {/* 🔹 Totals */}
            <QuotationSummaryTotals />
          </>
        ) : (
          <QuotationSummaryEmpty />
        )}

        {/* ===================================================== */}
        {/* 🔹 Footer */}
        {/* ===================================================== */}
        <div
          className="
          border-t
          border-stroke

          pt-5

          dark:border-strokedark
        "
        >
          <QuotationFooterActions />
        </div>
      </div>
    </section>
  );
};

export default QuotationSummaryPanel;
